const initialBasket = {
  promotionEngineValidationError: false,
  carrier: {
    preferred: { carrierKey: 'dhl', key: 'standard_delivery' },
    selected: { carrierKey: 'dhl', key: 'standard_delivery' },
    list: [
      {
        carrierKey: 'dhl',
        key: 'standard_delivery',
        isDisabled: false,
        isHidden: false,
        deliveryDays: { minimum: 1, maximum: 2 }
      },
      {
        carrierKey: 'hermes',
        key: 'standard_delivery',
        isDisabled: true,
        isHidden: true,
        deliveryDays: { minimum: 1, maximum: 2 }
      }
    ]
  },
  discount: { campaign: 0, sale: 0, promotion: 0 },
  id: 'aboutyou_customer_32633378',
  memberships: [{ type: 'payback', earnings: 184 }],
  packages: [
    {
      carrierGroupKey: 'dhl',
      carriers: ['dhl', 'hermes'],
      deliveryDate: { min: '2021-05-26', max: '2021-05-31' },
      id: 3,
      isAvailable: true,
      items: [
        {
          brand: { id: 364, name: 'TOMMY HILFIGER' },
          colors: [{ id: 38911, name: 'wei\u00df' }],
          id: '98d18228d075bbe2fec278dbcb76eb28',
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/d862f98cb47f3278bb92d86fc582e68e',
          pdpUrl: 'https://www.aboutyou.de/p/tommy-hilfiger/sneaker-3936341',
          merchant: { id: 130, variantId: 'THS1929001000007' },
          name: 'Sneaker',
          quantity: 1,
          isQuantityChangeDisabled: true,
          productId: 3936341,
          variantId: 35360450,
          styleKey: 'THS1929-5',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Wei\u00df' },
              { label: { translationKey: 'size' }, value: '45' },
              { label: { translationKey: 'unset' }, value: '14 Day Returns' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'THS1929001000007' },
            meta: { label: { translationKey: 'meta' }, value: 'TOMMY HILFIGER' },
            name: { label: { translationKey: 'name' }, value: 'Sneaker' }
          },
          additionalData: {
            variantId: 35360450,
            productId: 3936341,
            linkedContentType: null,
            linkedContentId: null,
            wt_sdk: {
              variantId: 35360450,
              sizeLabel: '45',
              supplierId: 130,
              strikeOutPrice: null,
              category: null,
              categoryId: null,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|3936341|simple|||',
              sourceHistoryOne: 'adp|4469114|reco|fittingProductsReco||',
              sourceHistoryTwo: 'browse|||||',
              sourceHistoryThree: 'wishlist|||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          deliveryForecast: { deliverable: 'available' },
          unit: {
            costWithTaxWithoutVoucher: 9990,
            costWithoutTaxWithoutVoucher: 8395,
            taxWithoutVoucher: 1595,
            taxRate: 19
          },
          size: { dimension3: null, length: null, shop: '45', vendor: '45' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          lowestPriorPrice: { withTax: 7500 },
          total: {
            costWithTaxWithoutDiscount: 21800,
            costWithTaxWithDiscount: 8580,
            costWithoutTaxWithDiscount: 7580,
            costWithoutTaxWithoutDiscount: 20000
          },
          discount: {
            sale: 1983,
            saleWithoutTax: 1583,
            campaign: 6610,
            campaignWithoutTax: 6210,
            voucher: 4627,
            voucherWithoutTax: 4227,
            total: 82110
          }
        },
        {
          brand: { id: 364, name: 'FIELMANN CHARME 0508 MOD TITAN TR' },
          colors: [{ id: 38911, name: 'wei\u00df' }],
          id: '90d18228d075bbe2fec278dbcb76eb28',
          itemGroup: {
            id: '1234567',
            isMainItem: true,
            isRequired: false
          },
          warehouseId: null,
          imageUrl:
            'https://fim-prev.cdn.aboutyou.cloud/images/d12aa9941383863e030038d49d914cec.png?brightness=1&width=1536&height=860&quality=85&bg=FFFFFF',
          pdpUrl:
            'https://fim.storefront.staging.aboutyou.cloud/p/fielmann-charme-0508-mod-titan-tr-315m-blau_matt-1247/?variantid=11998',
          merchant: { id: 130, variantId: 'THS1929001000007' },
          name: 'Vetro Glasses',
          quantity: 1,
          isQuantityChangeDisabled: true,
          productId: 3936341,
          variantId: 35360450,
          styleKey: 'THS1929-5',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Gray' },
              { label: { translationKey: 'size' }, value: 'M' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'THS1929001000007' },
            meta: { label: { translationKey: 'meta' }, value: 'TOMMY HILFIGER' },
            name: { label: { translationKey: 'name' }, value: 'Sneaker' }
          },
          additionalData: {
            variantId: 35360450,
            productId: 3936341,
            linkedContentType: null,
            linkedContentId: null,
            wt_sdk: {
              variantId: 35360450,
              sizeLabel: '45',
              supplierId: 130,
              strikeOutPrice: null,
              category: null,
              categoryId: null,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|3936341|simple|||',
              sourceHistoryOne: 'adp|4469114|reco|fittingProductsReco||',
              sourceHistoryTwo: 'browse|||||',
              sourceHistoryThree: 'wishlist|||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          deliveryForecast: { subsequentDelivery: 'endOfJuly' },
          unit: {
            costWithTaxWithoutVoucher: 9990,
            costWithoutTaxWithoutVoucher: 8395,
            taxWithoutVoucher: 1595,
            taxRate: 19
          },
          size: { dimension3: null, length: null, shop: 'M', vendor: 'M' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          lowestPriorPrice: { withTax: 7500 },
          total: {
            costWithTaxWithoutDiscount: 15000,
            costWithTaxWithDiscount: 10000,
            costWithoutTaxWithDiscount: 7580,
            costWithoutTaxWithoutDiscount: 20000
          },
          discount: {
            sale: 0,
            saleWithoutTax: 0,
            campaign: 0,
            campaignWithoutTax: 0,
            voucher: 5000,
            voucherWithoutTax: 4500,
            total: 5000
          }
        },
        {
          brand: { id: 408, name: 'FIELMANN' },
          categoryName: null,
          colors: [{ id: 38769, name: 'dunkelblau' }],
          id: '8757177c3bad17ece14766408bdc691d',
          itemGroup: {
            id: '1234567',
            isMainItem: false,
            isRequired: false
          },
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/08354a49f63075ff78bbadc7dc1e40c9',
          pdpUrl: 'https://www.aboutyou.de/p/scotch-soda/jeans-nos-ralston-3918099',
          merchant: { id: 130, variantId: 'SCO0784001000009' },
          name: 'Smart frame',
          quantity: 1,
          productId: 3918099,
          variantId: 35251824,
          styleKey: 'SCO0784-5',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Dunkelblau' },
              { label: { translationKey: 'size' }, value: '31' },
              { label: { translationKey: 'length' }, value: '32' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'SCO0784001000009' },
            meta: { label: { translationKey: 'meta' }, value: 'SCOTCH & SODA' },
            name: { label: { translationKey: 'name' }, value: "Jeans 'NOS Ralston'" }
          },
          additionalData: {
            variantId: 35251824,
            productId: 3918099,
            sortingChannel: 'web_size',
            linkedContentType: 'category',
            linkedContentId: 20331,
            wt_sdk: {
              variantId: 35251824,
              sizeLabel: '31',
              supplierId: 130,
              strikeOutPrice: null,
              category: '/maenner/bekleidung/jeans',
              categoryId: 20331,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|3918099|simple|||',
              sourceHistoryOne: 'category|20331|stream|||',
              sourceHistoryTwo: 'category|20331||||',
              sourceHistoryThree: 'category|20330||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          unit: {
            costWithTaxWithoutVoucher: 9990,
            costWithoutTaxWithoutVoucher: 8395,
            taxWithoutVoucher: 1595,
            taxRate: 19
          },
          size: { dimension3: null, length: '32', shop: '31', vendor: '31' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          lowestPriorPrice: { withTax: 15900 },
          total: {
            costWithTaxWithoutDiscount: 19900,
            costWithTaxWithDiscount: 14230,
            costWithoutTaxWithDiscount: 12000,
            costWithoutTaxWithoutDiscount: 18000
          },
          discount: {
            sale: 2000,
            saleWithoutTax: 1500,
            campaign: 1500,
            campaignWithoutTax: 1250,
            voucher: 2170,
            voucherWithoutTax: 1800,
            total: 5670
          }
        },
        {
          brand: { id: 408, name: 'FIELMANN' },
          categoryName: null,
          colors: [{ id: 38769, name: 'dunkelblau' }],
          id: '8757177c3bad11ece14766408bdc691d',
          itemGroup: {
            id: '1234567',
            isMainItem: false,
            isRequired: true
          },
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/08354a49f63075ff78bbadc7dc1e40c9',
          pdpUrl: 'https://www.aboutyou.de/p/scotch-soda/jeans-nos-ralston-3918099',
          merchant: { id: 130, variantId: 'SCO0784001000009' },
          name: 'Polarized',
          quantity: 1,
          productId: 3918099,
          variantId: 35251824,
          styleKey: 'SCO0784-5',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Dunkelblau' },
              { label: { translationKey: 'size' }, value: '31' },
              { label: { translationKey: 'length' }, value: '32' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'SCO0784001000009' },
            meta: { label: { translationKey: 'meta' }, value: 'SCOTCH & SODA' },
            name: { label: { translationKey: 'name' }, value: "Jeans 'NOS Ralston'" }
          },
          additionalData: {
            variantId: 35251824,
            productId: 3918099,
            sortingChannel: 'web_size',
            linkedContentType: 'category',
            linkedContentId: 20331,
            wt_sdk: {
              variantId: 35251824,
              sizeLabel: '31',
              supplierId: 130,
              strikeOutPrice: null,
              category: '/maenner/bekleidung/jeans',
              categoryId: 20331,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|3918099|simple|||',
              sourceHistoryOne: 'category|20331|stream|||',
              sourceHistoryTwo: 'category|20331||||',
              sourceHistoryThree: 'category|20330||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          unit: {
            costWithTaxWithoutVoucher: 9990,
            costWithoutTaxWithoutVoucher: 8395,
            taxWithoutVoucher: 1595,
            taxRate: 19
          },
          size: { dimension3: null, length: '32', shop: '31', vendor: '31' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          lowestPriorPrice: { withTax: 15900 },
          total: {
            costWithTaxWithoutDiscount: 3500,
            costWithTaxWithDiscount: 3500,
            costWithoutTaxWithDiscount: 3000,
            costWithoutTaxWithoutDiscount: 3100
          },
          discount: {
            sale: 0,
            saleWithoutTax: 0,
            campaign: 0,
            campaignWithoutTax: 0,
            voucher: 0,
            voucherWithoutTax: 0,
            total: 0
          }
        },
        {
          brand: { id: 408, name: 'FIELMANN' },
          categoryName: null,
          colors: [{ id: 38769, name: 'dunkelblau' }],
          id: '8757177c3bad17ece14726408bdc691d',
          itemGroup: {
            id: '1234567',
            isMainItem: false,
            isRequired: false
          },
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/08354a49f63075ff78bbadc7dc1e40c9',
          pdpUrl: 'https://www.aboutyou.de/p/scotch-soda/jeans-nos-ralston-3918099',
          merchant: { id: 130, variantId: 'SCO0784001000009' },
          name: 'Anti glare',
          quantity: 1,
          productId: 3918099,
          variantId: 35251824,
          styleKey: 'SCO0784-5',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Dunkelblau' },
              { label: { translationKey: 'size' }, value: '31' },
              { label: { translationKey: 'length' }, value: '32' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'SCO0784001000009' },
            meta: { label: { translationKey: 'meta' }, value: 'SCOTCH & SODA' },
            name: { label: { translationKey: 'name' }, value: "Jeans 'NOS Ralston'" }
          },
          additionalData: {
            variantId: 35251824,
            productId: 3918099,
            sortingChannel: 'web_size',
            linkedContentType: 'category',
            linkedContentId: 20331,
            wt_sdk: {
              variantId: 35251824,
              sizeLabel: '31',
              supplierId: 130,
              strikeOutPrice: null,
              category: '/maenner/bekleidung/jeans',
              categoryId: 20331,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|3918099|simple|||',
              sourceHistoryOne: 'category|20331|stream|||',
              sourceHistoryTwo: 'category|20331||||',
              sourceHistoryThree: 'category|20330||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          unit: {
            costWithTaxWithoutVoucher: 9990,
            costWithoutTaxWithoutVoucher: 8395,
            taxWithoutVoucher: 1595,
            taxRate: 19
          },
          size: { dimension3: null, length: '32', shop: '31', vendor: '31' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          lowestPriorPrice: { withTax: 15900 },
          total: {
            costWithTaxWithoutDiscount: 4000,
            costWithTaxWithDiscount: 3100,
            costWithoutTaxWithDiscount: 2700,
            costWithoutTaxWithoutDiscount: 3100
          },
          discount: {
            sale: 0,
            saleWithoutTax: 0,
            campaign: 0,
            campaignWithoutTax: 0,
            voucher: 0,
            voucherWithoutTax: 0,
            total: 0
          }
        },
        {
          brand: { id: 408, name: 'FIELMANN' },
          categoryName: null,
          colors: [{ id: 38769, name: 'dunkelblau' }],
          id: '8757177c3bad17ece14766408bdc694d',
          itemGroup: {
            id: '1234567',
            isMainItem: false,
            isRequired: false
          },
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/08354a49f63075ff78bbadc7dc1e40c9',
          pdpUrl: 'https://www.aboutyou.de/p/scotch-soda/jeans-nos-ralston-3918099',
          merchant: { id: 130, variantId: 'SCO0784001000009' },
          name: 'X-ray vision',
          quantity: 1,
          productId: 3918099,
          variantId: 35251824,
          styleKey: 'SCO0784-5',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Dunkelblau' },
              { label: { translationKey: 'size' }, value: '31' },
              { label: { translationKey: 'length' }, value: '32' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'SCO0784001000009' },
            meta: { label: { translationKey: 'meta' }, value: 'SCOTCH & SODA' },
            name: { label: { translationKey: 'name' }, value: "Jeans 'NOS Ralston'" }
          },
          additionalData: {
            variantId: 35251824,
            productId: 3918099,
            sortingChannel: 'web_size',
            linkedContentType: 'category',
            linkedContentId: 20331,
            wt_sdk: {
              variantId: 35251824,
              sizeLabel: '31',
              supplierId: 130,
              strikeOutPrice: null,
              category: '/maenner/bekleidung/jeans',
              categoryId: 20331,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|3918099|simple|||',
              sourceHistoryOne: 'category|20331|stream|||',
              sourceHistoryTwo: 'category|20331||||',
              sourceHistoryThree: 'category|20330||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          unit: {
            costWithTaxWithoutVoucher: 9990,
            costWithoutTaxWithoutVoucher: 8395,
            taxWithoutVoucher: 1595,
            taxRate: 19
          },
          size: { dimension3: null, length: '32', shop: '31', vendor: '31' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          lowestPriorPrice: { withTax: 15900 },
          total: {
            costWithTaxWithoutDiscount: 7000,
            costWithTaxWithDiscount: 7000,
            costWithoutTaxWithDiscount: 6500,
            costWithoutTaxWithoutDiscount: 6500
          },
          discount: {
            sale: 0,
            saleWithoutTax: 0,
            campaign: 0,
            campaignWithoutTax: 0,
            voucher: 0,
            voucherWithoutTax: 0,
            total: 0
          }
        },
        {
          brand: { id: 408, name: 'FIELMANN' },
          categoryName: null,
          colors: [{ id: 38769, name: 'dunkelblau' }],
          id: '8757177c3bad17ece14766408bdc692d',
          itemGroup: {
            id: '1234567',
            isMainItem: false,
            isRequired: true
          },
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/08354a49f63075ff78bbadc7dc1e40c9',
          pdpUrl: 'https://www.aboutyou.de/p/scotch-soda/jeans-nos-ralston-3918099',
          merchant: { id: 130, variantId: 'SCO0784001000009' },
          name: 'Indestructible case',
          quantity: 1,
          productId: 3918099,
          variantId: 35251824,
          styleKey: 'SCO0784-5',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Dunkelblau' },
              { label: { translationKey: 'size' }, value: '31' },
              { label: { translationKey: 'length' }, value: '32' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'SCO0784001000009' },
            meta: { label: { translationKey: 'meta' }, value: 'SCOTCH & SODA' },
            name: { label: { translationKey: 'name' }, value: "Jeans 'NOS Ralston'" }
          },
          additionalData: {
            variantId: 35251824,
            productId: 3918099,
            sortingChannel: 'web_size',
            linkedContentType: 'category',
            linkedContentId: 20331,
            wt_sdk: {
              variantId: 35251824,
              sizeLabel: '31',
              supplierId: 130,
              strikeOutPrice: null,
              category: '/maenner/bekleidung/jeans',
              categoryId: 20331,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|3918099|simple|||',
              sourceHistoryOne: 'category|20331|stream|||',
              sourceHistoryTwo: 'category|20331||||',
              sourceHistoryThree: 'category|20330||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          unit: {
            costWithTaxWithoutVoucher: 9990,
            costWithoutTaxWithoutVoucher: 8395,
            taxWithoutVoucher: 1595,
            taxRate: 19
          },
          size: { dimension3: null, length: '32', shop: '31', vendor: '31' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          lowestPriorPrice: { withTax: 15900 },
          total: {
            costWithTaxWithoutDiscount: 2500,
            costWithTaxWithDiscount: 500,
            costWithoutTaxWithDiscount: 250,
            costWithoutTaxWithoutDiscount: 2000
          },
          discount: {
            sale: 500,
            saleWithoutTax: 420,
            campaign: 0,
            campaignWithoutTax: 0,
            voucher: 1500,
            voucherWithoutTax: 1250,
            total: 2000
          }
        }
      ]
    },
    {
      carrierGroupKey: 'dhl',
      carriers: ['dhl'],
      deliveryDate: { min: '2021-05-27', max: '2021-05-28' },
      id: 1,
      isAvailable: true,
      items: [
        {
          brand: { id: 4352, name: 'POLO RALPH LAUREN' },
          categoryName: null,
          colors: [
            { id: 38895, name: 'feuerrot' },
            { id: 38905, name: 'schwarz' }
          ],
          id: '2bed5f9fffe34b0ae59ec3239b4b78dc',
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/images/c3323055683aea69d58cc4ed10a70169.jpg',
          pdpUrl: 'https://www.aboutyou.de/p/polo-ralph-lauren/sweatshirt-6548444',
          merchant: { id: 145, variantId: '502510000109920' },
          name: 'Shirt',
          quantity: 1,
          productId: 6548444,
          variantId: 45196611,
          styleKey: '15051-145',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Feuerrot & Schwarz' },
              { label: { translationKey: 'size' }, value: 'M' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: '502510000109920' },
            meta: { label: { translationKey: 'meta' }, value: 'POLO RALPH LAUREN' },
            name: { label: { translationKey: 'name' }, value: 'Shirt' }
          },
          additionalData: {
            variantId: 45196611,
            productId: 6548444,
            linkedContentType: null,
            linkedContentId: null,
            wt_sdk: {
              variantId: 45196611,
              sizeLabel: 'M',
              supplierId: 145,
              strikeOutPrice: null,
              category: null,
              categoryId: null,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|6548444|simple|||',
              sourceHistoryOne: 'browse|||||',
              sourceHistoryTwo: 'account_area:login_security|||||',
              sourceHistoryThree: 'account_area:orders_detailview|||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          unit: {
            costWithTaxWithoutVoucher: 7999,
            costWithoutTaxWithoutVoucher: 6722,
            taxWithoutVoucher: 1277,
            taxRate: 19
          },
          size: { dimension3: null, length: null, shop: 'M', vendor: 'M' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          total: {
            costWithTaxWithoutDiscount: 6300,
            costWithTaxWithDiscount: 6300,
            costWithoutTaxWithDiscount: 5700,
            costWithoutTaxWithoutDiscount: 5700
          },
          discount: {
            sale: 0,
            saleWithoutTax: 0,
            campaign: 0,
            campaignWithoutTax: 0,
            voucher: 0,
            voucherWithoutTax: 0,
            total: 0
          }
        }
      ]
    },
    {
      carrierGroupKey: 'dhl',
      carriers: ['dhl'],
      deliveryDate: { min: '2021-05-27', max: '2021-05-28' },
      id: 2,
      isAvailable: true,
      items: [
        {
          brand: { id: 389, name: 'Calvin Klein' },
          categoryName: null,
          colors: [{ id: 38749, name: 'navy' }],
          id: 'bb7209fb644dad03cbf6cf1d07b458c4',
          warehouseId: null,
          imageUrl: 'https://cdn.aboutyou.de/file/images/aee73c9ec9490305ec4f000c741758f5',
          pdpUrl: 'https://www.aboutyou.de/p/calvin-klein/sweatshirt-4469114',
          merchant: { id: 164, variantId: 'K10K104059407003' },
          name: 'Sweatshirt',
          quantity: 1,
          productId: 4469114,
          variantId: 38518879,
          styleKey: '968505833-1',
          displayData: {
            attributes: [
              { label: { translationKey: 'color' }, value: 'Navy' },
              { label: { translationKey: 'size' }, value: 'M Normalgr\u00f6\u00dfen' }
            ],
            identifier: { label: { translationKey: 'identifier' }, value: 'K10K104059407003' },
            meta: { label: { translationKey: 'meta' }, value: 'Calvin Klein' },
            name: { label: { translationKey: 'name' }, value: 'Sweatshirt' }
          },
          additionalData: {
            variantId: 38518879,
            productId: 4469114,
            linkedContentType: null,
            linkedContentId: null,
            wt_sdk: {
              variantId: 38518879,
              sizeLabel: 'M',
              supplierId: 164,
              strikeOutPrice: null,
              category: null,
              categoryId: null,
              sourceCategory: null,
              sourceCategoryId: null,
              position: 1,
              sectionIndexOnPage: 2,
              rowIndexInSection: 1,
              columnIndexInSection: 1,
              initiallyVisibleColumns: 1,
              source: 'adp|4469114|simple|||',
              sourceHistoryOne: 'browse|||||',
              sourceHistoryTwo: 'wishlist|||||',
              sourceHistoryThree: 'browse|||||',
              sort: '',
              filter: '',
              fitAnalyticsUsed: false
            },
            originDevice: 'desktop'
          },
          unit: {
            costWithTaxWithoutVoucher: 8990,
            costWithoutTaxWithoutVoucher: 7555,
            taxWithoutVoucher: 1435,
            taxRate: 19
          },
          size: { dimension3: 'Normalgr\u00f6\u00dfen', length: null, shop: 'M', vendor: 'M' },
          voucherId: 'd3b07384d113edec49eaa6238ad5ff00',
          total: {
            costWithTaxWithoutDiscount: 8990,
            costWithTaxWithDiscount: 8990,
            costWithoutTaxWithDiscount: 7630,
            costWithoutTaxWithoutDiscount: 7630
          },
          discount: {
            sale: 0,
            saleWithoutTax: 0,
            campaign: 0,
            campaignWithoutTax: 0,
            voucher: 0,
            voucherWithoutTax: 0,
            total: 0
          }
        }
      ]
    }
  ],
  paymentTypes: [{ key: 'paypal_instant', partialCost: 36969, installment: null, isDeferred: false }],
  requiresAdditionalPaymentMethod: false,
  pricingEstimations: {
    items: [
      {
        id: 100000,
        duties: {
          localCurrency: {
            amount: 600,
            currency: 'SAR'
          },
          originalCurrency: {
            amount: 399,
            currency: 'USD'
          },
          rate: 0.19
        },
        price: {
          localCurrency: {
            amount: 5500,
            currency: 'SAR'
          },
          originalCurrency: {
            amount: 2379,
            currency: 'USD'
          }
        },
        taxes: {
          localCurrency: {
            amount: 600,
            currency: 'SAR'
          },
          originalCurrency: {
            amount: 399,
            currency: 'USD'
          },
          rate: 0.19
        },
        totalFees: {
          localCurrency: {
            amount: 600,
            currency: 'SAR'
          },
          originalCurrency: {
            amount: 399,
            currency: 'USD'
          }
        }
      }
    ],
    totals: {
      duties: {
        localCurrency: {
          amount: 600.99,
          currency: 'SAR'
        },
        originalCurrency: {
          amount: 399.22,
          currency: 'USD'
        }
      },
      taxes: {
        localCurrency: {
          amount: 600.99,
          currency: 'SAR'
        },
        originalCurrency: {
          amount: 399.22,
          currency: 'USD'
        }
      },
      totalFees: {
        localCurrency: {
          amount: 600,
          currency: 'SAR'
        },
        originalCurrency: {
          amount: 399,
          currency: 'USD'
        }
      }
    }
  },
  tax: { amount: 5902 },
  total: {
    costPaymentServiceCosts: 47,
    costShippingServiceCosts: 410,
    costWithTaxWithVouchersWithServiceCosts: 36969,
    costWithTaxWithVouchersWithServiceCostsWithGiftCard: 36969,
    costWithTaxWithVouchersWithServiceCostsWithoutGiftCard: 36969,
    costWithTaxWithVouchersWithoutServiceCosts: 36969,
    costWithTaxWithoutAbsoluteVouchersWithoutServiceCosts: 36969,
    costWithTaxWithoutPromotion: 62700,
    itemGroups: {
      '1234567': {
        brutto: 23800,
        bruttoDiscount: 0,
        bruttoDiscountWithoutMainProduct: 0,
        bruttoWithoutMainProduct: 11900,
        netto: 19833,
        nettoWithoutMainProduct: 9916,
        tax: 3966,
        taxWithoutMainProduct: 1983
      }
    }
  },
  serviceCosts: [],
  vouchers: [],
  deliveryOptions: {
    same_billing_shipping: { isDisabled: false },
    diverging_billing_shipping: { isDisabled: false },
    address_forwarding: [],
    click_and_collect: [],
    collection_points: [
      { key: 'hermes_parcelshop', carrierKey: 'hermes', isDisabled: true, imageFileName: 'hermes_parcel_shop.svg' },
      { key: 'dhl_postoffice', carrierKey: 'dhl', isDisabled: true, imageFileName: 'dhl_post_office.svg' },
      { key: 'dhl_packstation', carrierKey: 'dhl', isDisabled: true, imageFileName: 'dhl_packstation.svg' }
    ]
  },
  collectionPoints: [
    { key: 'hermes_parcelshop', carrierKey: 'hermes', isDisabled: true, imageFileName: 'hermes_parcel_shop.svg' },
    { key: 'dhl_postoffice', carrierKey: 'dhl', isDisabled: true, imageFileName: 'dhl_post_office.svg' },
    { key: 'dhl_packstation', carrierKey: 'dhl', isDisabled: true, imageFileName: 'dhl_packstation.svg' }
  ]
};

export default initialBasket;
